import { inject, Injectable } from '@angular/core';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { map, Observable, tap } from 'rxjs';
import { NavDataService } from '..';
import { AuthSessionService } from '../auth-session/auth-session.service';
import { ModalManagerService, ModalTypes } from '../modal-manager';

@Injectable({
  providedIn: 'root',
})
export class ContentProtectionService {
  private navDataService: NavDataService = inject(NavDataService);
  private modalManagerService: ModalManagerService = inject(ModalManagerService);
  private localizeRouterService: LocalizeRouterService = inject(LocalizeRouterService);
  private authSessionService: AuthSessionService = inject(AuthSessionService);

  /**
   * Handle the protection of the current content from unauthorized access.
   * @param {string} [urlToProtect]
   * Url to protect, if not present will use the current url.
   * @param {string} [needToNavigateBack]
   * True if the modal need to navigate back after closing, default true.
   */
  protect(urlToProtect?: string, needToNavigateBack = true): void {
    this.authSessionService.isLogged
      ? this.protectWithModalSubscription(needToNavigateBack)
      : this.protectWithLogin(urlToProtect).subscribe();
  }

  /**
   * Protect the current route with membership modal,
   * after closing navigating back to the previous page,
   * if it's not present in the history, will go to account.
   * @param {string} [needToNavigateBack]
   * True if the modal need to navigate back after closing, default true.
   */
  protectWithModalSubscription(needToNavigateBack = true): void {
    this.modalManagerService.open(ModalTypes.subscriptions).subscribe(() => {
      if (needToNavigateBack) {
        this.navDataService.history.navigateBack('/account');
      }
    });
  }

  /**
   * Protect the current route with redirect to login page,
   * keeping the destination after login.
   * @param {string} [urlToProtect]
   * Optional: url to protect, if not present will use the current url.
   * @param {string} [needToTranslate]
   * Optional: url to protect, if not present will use the current url.
   */
  protectWithLogin(urlToProtect?: string, needToTranslate?: boolean): Observable<boolean> {
    return this.modalManagerService.open(ModalTypes.LoginRegister).pipe(
      map((result) => result && result !== -1),
      tap((loginDone) =>
        loginDone && urlToProtect ? this.navDataService.navigate(urlToProtect, false, undefined, needToTranslate) : null
      )
    );
  }
}
